import {safeParseJson, findParent} from '../../js/tools';

const Classes = {
  OPEN: 'open',
};

export class Modal {
	elements = {
	  root: null,
		content: null,
    trigger: null,
  };
  state = {
    isOpen: false,
  };
  model = null;

  constructor(element) {
    if (!element) {
      return;
    }

    this.model = safeParseJson(element.dataset.model);
    this.elements = {
      root: element,
      content: element.querySelector('.content'),
      trigger: document.querySelectorAll(this.model.triggerElement),
      closeButton: element.querySelector('.close-button'),
    };

    this.addListeners();
  }

  addListeners() {
    // Trigger can be a single element or multiple.
    // If multiple, use event delegaton.
    if (!this.elements.trigger?.length) {
      return;

    }
    if (this.elements.trigger.length > 1) {
      document.addEventListener('click', (event) => {
        if (findParent(event.target, this.model.triggerElement)) {
          this.toggle();
        }
      });
    } else {
      this.elements.trigger[0].addEventListener('click', () => {
        this.toggle();
      });
    }

    document.addEventListener('click', (event) => {
      const isContentClick = !!findParent(event.target, this.elements.content);
      const isRootClick = !!findParent(event.target, this.elements.root);
      const isCloseButtonClick = !!findParent(event.target, this.elements.closeButton);

      if (isCloseButtonClick || isRootClick && !isContentClick) {
        if (this.state.isOpen) {
          this.close();
        }
      }
    });

    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  toggle() {
    this.state.isOpen = !this.state.isOpen;
    this.update();
  }

	open() {
	  this.state.isOpen = true;
		this.update();
	}

	close() {
	  this.state.isOpen = false;
		this.update();
	}

	update() {
	  if (this.state.isOpen) {
	    this.elements.root.classList.add(Classes.OPEN);
	  } else {
			this.elements.root.classList.remove(Classes.OPEN);
		}
	}
}
